import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { server, RECAPTCHA_KEY, GOOGLE_CLIENT_ID, discordURL } from "../env";
import axios from "axios";
import Cookies from "js-cookie";
import Loader from "../components/Loader";
import Alert from "../components/Alert";
import Recaptcha from "react-google-invisible-recaptcha";
import {
  GoogleLoginButton,
  // TwitterLoginButton,
  DiscordLoginButton,
} from "react-social-login-buttons";

export default class Signup extends PureComponent {
  state = {
    showPassword: false,
    loader: "",
    message: "",
    ref: "",
  };

  componentDidMount = () => {
    document.title = "Create New Account - Proxies.gg";
    const href = window.location.href;
    const ref = href.split("ref=");
    if (ref.length > 0) {
      localStorage.setItem("ref", ref[1]);
      this.setState({ ref: ref[1] });
    }
  };

  handlePasswordVisiblity = () => {
    this.setState({
      showPassword: this.state.showPassword ? false : true,
    });
  };

  signup = async (e) => {
    e.preventDefault();
    this.setState({
      loader: <Loader />,
      message: "",
    });

    await this.recaptcha.execute();

    var params = Array.from(e.target.elements)
      .filter((el) => el.name)
      .reduce((a, b) => ({ ...a, [b.name]: b.value }), {});
    params["g-recaptcha-response"] = this.state.reCaptcha;

    localStorage.setItem("email", e.target.email.value);

    await axios
      .post(server + "/v1/auth/signup", params)
      .then(async (rsp) => {
        this.setState({
          loader: "",
          message: <Alert className="success" message={rsp.data.detail} />,
        });
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 422) {
            this.setState({
              message: (
                <Alert className="warning" message={err.response.data.detail} />
              ),
            });
            this.props.history.push("/confirm-authentication");
          } else {
            this.setState({
              message: (
                <Alert className="danger" message={err.response.data.detail} />
              ),
            });
          }
        }
        this.setState({
          loader: "",
        });
      });
  };

  onResolved = () => {
    this.setState({ reCaptcha: this.recaptcha.getResponse() });
  };

  googleLogin = () => {
    const gapi = window.gapi;
    const self = this;

    gapi.load("auth2", function () {
      let auth2 = gapi.auth2.init({
        client_id: GOOGLE_CLIENT_ID,
        ux_mode: "redirect",
      });
      auth2.grantOfflineAccess().then((token) => {
        const params = {
          token: token.code,
          referee: self.state.ref,
        };

        self.setState({
          loader: <Loader />,
          message: "",
        });

        axios
          .post(server + "/v1/auth/google", params)
          .then((rsp) => {
            Cookies.set("token", rsp.data.payload.token);
            self.setState({
              loader: "",
              message: <Alert className="success" message={rsp.data.detail} />,
            });
            window.location.href = "/";
          })
          .catch((err) => {
            self.setState({
              message: (
                <Alert className="warning" message={err.response.data.detail} />
              ),
              loader: "",
            });
          });
      });
    });
  };

  discordLogin = async () => {
    this.setState({
      loader: <Loader />,
    });

    window.location.href = discordURL;
  };

  render() {
    const { showPassword } = this.state;
    const { message, loader, ref } = this.state;
    return (
      <div className="col-12 col-md-5 col-xl-4 my-5">
        <h1 className="display-4 text-center mb-3">Sign Up</h1>

        <p className="text-muted text-center mb-5">
          Create new account and enjoy Proxies.gg dashboard.
        </p>

        <form onSubmit={this.signup}>
          {message}
          <div className="form-group">
            <label className="form-label"> Username </label>

            <input
              type="text"
              className="form-control"
              placeholder="Enter username"
              name="username"
              autoFocus
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label"> Email </label>

            <input
              type="email"
              className="form-control"
              placeholder="Enter email"
              name="email"
              required
            />
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col">
                <label className="form-label"> Password </label>
              </div>
            </div>
            <div className="input-group input-group-merge">
              <input
                className="form-control"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                name="password"
                required
              />

              <span
                className="input-group-text"
                onClick={this.handlePasswordVisiblity}
              >
                {showPassword ? (
                  <i className="fe fe-eye-off"></i>
                ) : (
                  <i className="fe fe-eye"></i>
                )}
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label"> Referral Code (optional) </label>

            <input
              type="text"
              className="form-control"
              placeholder="Enter referral code"
              name="referee"
              value={ref}
              onChange={(e) => this.setState({ ref: e.target.value })}
            />
          </div>

          <button className="btn btn-lg w-100 btn-primary mb-3">
            Sign Up {loader}
          </button>
          <div className="text-center">OR</div>

          <GoogleLoginButton
            onClick={this.googleLogin}
            style={{ borderRadius: "0.5rem" }}
            text="Continue with Google"
          />
          <DiscordLoginButton
            style={{ borderRadius: "0.5rem" }}
            onClick={this.discordLogin}
          />
          <div className="text-center">
            <small className="text-muted text-center">
              Have an account? <Link to="/">Log In</Link>.
            </small>
          </div>
        </form>
        <Recaptcha
          ref={(ref) => (this.recaptcha = ref)}
          sitekey={RECAPTCHA_KEY}
          onResolved={this.onResolved}
        />
      </div>
    );
  }
}
